import { createFileRoute } from '@tanstack/react-router'

import { MatchesPage } from '~/features/football-matches/matches-page'
import { matchesQueryOptions } from '~/features/football-matches/query-options'
import { matchesSearchSchema, parseMatchesSearch } from '~/features/football-matches/search-schema'
import { seo } from '~/utils/seo'
import { getPageMeta } from '~/utils/seo-meta'

export const Route = createFileRoute('/$locale/_public/matches')({
  validateSearch: parseMatchesSearch,
  head: ({ params }) => seo({
    ...getPageMeta('/matches', params.locale),
    pathname: '/matches',
    locale: params.locale,
  }),
  loader: async ({ context, location }) => {
    await context.queryClient.prefetchQuery(matchesQueryOptions(matchesSearchSchema.parse(location.search)))
  },
  component: LocalizedMatchesRoute,
})

function LocalizedMatchesRoute() {
  return <MatchesPage search={Route.useSearch()} />
}
